import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

export function slider() {
  const swiper = new Swiper('.js-slider', {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // 768px以上の場合
      769: {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
      },
    },
  });
}
